module.exports = __webpack_public_path__ + "img/full-shape.862f5969.svg";